import React from 'react'

export default function MarketingIconEnterprise (props) {
  return (
    <svg
      width="81"
      height="71"
      viewBox="0 0 81 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      role="img"
      aria-hidden="true"
    >
      <title>Enterprise ready</title>
      <path d="M11 5H43V66H11V5Z" fill="#0298BF" />
      <path d="M33 29H60V66H33V29Z" fill="#4CEB98" />
      <rect
        width="5.1807"
        height="12.0831"
        transform="matrix(-1 0 0 1 29.6875 28.8916)"
        fill="#61C8D7"
      />
      <rect
        width="5.1807"
        height="12.0831"
        transform="matrix(-1 0 0 1 29.6875 11.2612)"
        fill="#61C8D7"
      />
      <rect
        width="5.1807"
        height="12.0831"
        transform="matrix(-1 0 0 1 38.1316 11.2612)"
        fill="#61C8D7"
      />
      <rect
        width="5.1807"
        height="13.1816"
        transform="matrix(-1 0 0 1 29.6875 46.467)"
        fill="#61C8D7"
      />
      <rect
        width="5.1807"
        height="12.0831"
        transform="matrix(-1 0 0 1 21.3982 28.8916)"
        fill="#61C8D7"
      />
      <rect
        width="5.1807"
        height="12.0831"
        transform="matrix(-1 0 0 1 21.3982 11.2612)"
        fill="#61C8D7"
      />
      <rect
        width="5.1807"
        height="13.1816"
        transform="matrix(-1 0 0 1 21.3982 46.467)"
        fill="#61C8D7"
      />
      <rect
        width="5.50223"
        height="10.4353"
        transform="matrix(-1 0 0 1 53.7844 34.7407)"
        fill="#16CA6D"
      />
      <rect
        width="5.50223"
        height="10.4353"
        transform="matrix(-1 0 0 1 53.7844 49.3499)"
        fill="#16CA6D"
      />
      <rect
        width="5.50223"
        height="10.4353"
        transform="matrix(-1 0 0 1 44.1555 34.7407)"
        fill="#16CA6D"
      />
      <rect
        width="5.50223"
        height="10.4353"
        transform="matrix(-1 0 0 1 44.1555 49.3499)"
        fill="#16CA6D"
      />
      <path
        d="M49 29C49 22.9249 53.9249 18 60 18C66.0751 18 71 22.9249 71 29C71 35.0751 66.0751 40 60 40C53.9249 40 49 35.0751 49 29Z"
        fill="#222222"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.4007 32.0284L66.0158 26.4133L64.4297 24.8271L58.8146 30.4422L56.4143 28.0419L54.8281 29.6281L57.2284 32.0284L57.2281 32.0287L58.8142 33.6149L58.8146 33.6145L58.8153 33.6152L60.4014 32.029L60.4007 32.0284Z"
        fill="#7AEFB2"
      />
      <rect
        opacity="0.01"
        x="0.5"
        y="0.5"
        width="80"
        height="70"
        stroke="white"
      />
    </svg>
  )
}
